import { api } from '@utils'

import { GetAllArticleResponse, GetAllArticleParams, ArticleService } from '.'

const getAllArticle = async (
	params: GetAllArticleParams
): Promise<GetAllArticleResponse> => {
	try {
		const res = await api.get<GetAllArticleResponse>('/article', { params })
		return res.data
	} catch (e) {
		throw e
	}
}

export const articleService: ArticleService = {
	getAllArticle
}
